import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import { Col, Row } from 'elements'
import { formSubmit } from 'utils/form'
import { listClients } from 'redux/modules/model/client'
import { listAllSites, createZone } from 'redux/modules/model/site'
import { clientsSelector, allSitesInfoSelector } from 'redux/selectors'
import { ZoneForm } from 'smart-components'
import { PageContentTitle } from 'components'
import { withClientId } from 'hocs'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'operator-invite'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

class ZoneAdd extends Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    createZone: PropTypes.func.isRequired,
    listClients: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { clientId, listClients, listAllSites } = this.props
    listClients({ clientId })
    listAllSites({ clientId })
  }

  handleSubmit = (values) => {
    const { clientId, history, createZone } = this.props
    return formSubmit(createZone, { ...values })
      .then(() => history.push(ROUTES.ZONE))
  };

  render() {
    const { clientList, sites } = this.props
    return (
      <Row>
        <Col xs={24} sm={12} md={10}>
          <p className={bemE('back')}><Link to={ROUTES.ZONE}>&laquo; Back</Link></p>
          <PageContentTitle>Add a new zone</PageContentTitle>
          <ZoneForm onSubmit={this.handleSubmit} clients={clientList} sites={sites} />
        </Col>
      </Row>
    )
  }
}

export const selector = createStructuredSelector({
  clientList: clientsSelector,
  sites: allSitesInfoSelector
})

export const actions = {
  createZone,
  listClients,
  listAllSites
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(ZoneAdd)



// WEBPACK FOOTER //
// ./src/pages/zone/zone-add/index.js